import { render, staticRenderFns } from "./UpdatePaymentFormVerTwo.vue?vue&type=template&id=16b2bf3b&scoped=true&"
import script from "./UpdatePaymentFormVerTwo.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentFormVerTwo.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePaymentFormVerTwo.vue?vue&type=style&index=0&id=16b2bf3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b2bf3b",
  null
  
)

export default component.exports